import { vec3 } from "gl-matrix";
import { TraversabilityType } from "@spi/Common/Geometry";
import { PoolableObject, ObjectPool } from '@spi/Common/Util';

export enum VoxelFilling {
    Empty,
    Full,
    Conditional
}

export class Voxel implements PoolableObject {

    private approximateHeightList: number[];
    private _traversability: TraversabilityType;
    private _stepHeight: number;
    private _filling: VoxelFilling;
    public conditional: string;

    constructor(public voxelLocation: vec3 | number[], public min: vec3 | number[], public max: vec3 | number[]) {
        this.clear();
    }

    public get filling(): VoxelFilling {
        return this._filling;
    }

    public setFilling(filling: VoxelFilling, conditional?: string) {
        // TODO: check for filling overrides
        this.conditional = conditional;
        this._filling = filling;
    }

    public get traversability(): TraversabilityType {
        return this._traversability;
    }

    public set stepHeightOverride(s: number) {
        if (this._stepHeight === null) {
            this._stepHeight = s;
        }
    }

    public get stepHeightOverride(): number {
        return this._stepHeight;
    }

    public set traversability(t: TraversabilityType) {
        switch (this._traversability) {
            case TraversabilityType.Natural:
                // Natural slope can be overriden by anything.
                this._traversability = t;
                break;
            case TraversabilityType.Open:
                // Blocked can override an open span.
                if (t == TraversabilityType.Blocked) {
                    this._traversability = t;
                }
                break;
            case TraversabilityType.Blocked:
                // Nothing can override blocked.
                break;
        }
    }

    public addApproximateHeight(height: number) {
        if (height < this.min[2]) {
            this.approximateHeightList.push(this.min[2]);
        } else if (height > this.max[2]) {
            this.approximateHeightList.push(this.max[2]);
        } else {
            this.approximateHeightList.push(height);
        }
    }

    public getApproximateHeight() {

        switch (this.filling) {
            case VoxelFilling.Conditional:
            case VoxelFilling.Empty:
                return this.getMinHeight();
            case VoxelFilling.Full:
            default:
                return this.getMaxHeight();
        }
    }

    private getMinHeight() {
        if (this.approximateHeightList.length == 0) {
            return this.min[2];
        } else {
            return Math.min(...this.approximateHeightList);
        }
    }

    private getMaxHeight() {
        if (this.approximateHeightList.length == 0) {
            return this.max[2];
        } else {
            return Math.max(...this.approximateHeightList);
        }
    }

    public clear(): void {
        this.approximateHeightList = [];
        this._filling = VoxelFilling.Empty;
        this._traversability = TraversabilityType.Natural;
        this._stepHeight = null;
        this.conditional = null;
    }
}


export class VoxelPool extends ObjectPool<Voxel> {
    protected create(): Voxel {
        return new Voxel(vec3.create(), vec3.create(), vec3.create());
    }

}